import React, {useMemo} from "react";
import './ProgressBar.scoped.scss';

type ProgressLine = {
    readonly filled: number;
    readonly color: string; // In hex
}

type Props = {
    lines: Array<ProgressLine>
}

const ProgressBar = ({lines}: Props) => {
  const sortedLines = useMemo(() => {
    return [...lines].sort((a, b) => a.filled - b.filled);
  }, [lines]);
  const progressLines = sortedLines.map((line, index) => {
    const style = {
      backgroundColor: line.color,
      width: line.filled + "%"
    };
    return <div className="my-progress-bar" style={style} key={index}></div>;
  });
  return (
    <div className="my-progress-bar">
      {progressLines}
    </div>
  );
};

export default ProgressBar;